<template>
    <div class="documentManage">
        <div class="header">证件查看</div>
        <div class="nav">
            <img src="../assets/images/cas.png" alt="" class="nav_png">
        </div>
        <div class="main">
            <div class="box">
                <div class="tit">营业执照</div>
                <div class="png_box">
                    <img :src="businessCodeImg" alt="" class="license" v-if="businessCodeImg">
                    <img src="../assets/images/none.png" alt="" class="license" v-else>
                </div>
            </div>
            <div class="box" style="margin-top: 0.35rem;">
                <div class="tit">健康证</div>
                <div class="png_box">
                    <img :src="healthImg" alt="" class="license" v-if="healthImg">
                    <img src="../assets/images/none.png" alt="" class="license" v-else>
                </div>
            </div>
        </div>
        <div class="back" @click="back">
            <img src="../assets/images/back.png" alt="" class="back_png">
            <span class="back_word">返回</span>
        </div>
    </div>
</template>
<script>
import { getMerchant } from "@/api/home"
export default {
    data() {
        return {
            merId: '',
            businessCodeImg:'',
            healthImg:''
        }
    },
    created() {
        this.merId = this.$route.params.merId
    },
    mounted() {
        this.getAll()
    },
    methods: {
        getAll() {
            console.log(this.merId, '2')
            getMerchant({
                merId: this.merId
            }).then(res => {
                console.log(this.businessCodeImg,'2')
                this.businessCodeImg = res.data.businessCodeImg
                this.healthImg = res.data.healthImg

            }).catch(err => {
                //  alert(err)
            })

        },
        back() {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less" scoped>
.documentManage {

    .header {
        height: 0.9rem;
        line-height: 0.9rem;
        font-size: 0.32rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 400;
        color: #3E3E3E;
        background: #FFFFFF;
        opacity: 1;
    }

    .nav {
        height: 3.32rem;
        background: linear-gradient(180deg, rgba(34, 110, 217, 0.22) 0%, #FFFFFF 100%);

        .nav_png {
            width: 2.04rem;
            height: 2.04rem;
            float: right;
            margin: 0.3rem 0.46rem 0 0;
        }
    }

    .main {
        box-sizing: border-box;
        padding: 0 0.46rem;
        margin-top: -1.9rem;

        .box {

            .tit {
                text-align: left;
                height: 0.9rem;
                font-size: 0.36rem;
                font-weight: 400;
                color: #3D3D3D;
                line-height: 0.9rem;
            }

            .png_box {
                .license {
                    width: 100%;
                    height: 4rem;
                    border-radius: 0.15rem;
                    opacity: 1;
                }

            }
        }
    }

    .back {
        width: 1.74rem;
        height: 0.92rem;
        line-height: 0.92rem;
        background: #FFFFFF;
        box-shadow: 0rem 0.12rem 0.26rem -0.02rem #DCDCDC;
        border-radius: 0.2rem;
        position: fixed;
        bottom: 0.68rem;
        left: 0.24rem;

        .back_png {
            width: 0.3rem;
            height: 0.44rem;
            vertical-align: middle;
            margin-top: -0.1rem;
        }

        .back_word {
            font-size: 0.32rem;
            font-weight: 400;
            color: #3D3D3D;
            margin-left: 0.1rem;
        }
    }
}
</style>